"use client";

import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";

import { cn } from "@/lib/utils";

type SwitchProps = React.ComponentPropsWithoutRef<
  typeof SwitchPrimitives.Root
> & {
  variant?: "default" | "soft" | "peach";
};

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  SwitchProps
>(({ className, variant = "default", ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50",
      variant === "default" &&
        "border-transparent data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
      variant === "soft" &&
        "border-primary/30 data-[state=checked]:bg-primary/20 data-[state=unchecked]:bg-muted",
      variant === "peach" &&
        "border-[#f3cdb4] bg-[#f9f1ec] data-[state=checked]:bg-[#f9d9bf] data-[state=unchecked]:bg-[#f9f1ec]",
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0",
        variant === "soft" &&
          "data-[state=checked]:shadow-[0_0_0_2px_rgba(0,0,0,0.04)]",
        variant === "peach" &&
          "bg-white data-[state=checked]:shadow-[0_0_0_2px_rgba(244,179,120,0.35)]",
      )}
    />
  </SwitchPrimitives.Root>
));

Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
